import styles from "./Divider.module.scss";
import clsx from "clsx";

type TDividerProps = {
  className?: string;
  vertical?: boolean;
};

export function Divider({ className, vertical }: TDividerProps) {
  const directionClassName = vertical ? styles.verticalDivider : styles.horizontalDivider;
  return <div className={clsx(directionClassName, className)}></div>;
}
